/* eslint-disable */
var MGConstants = (function () {
  return {
    getWebRequest: function () {
      return {
        Verification_Token: {
          'MessageType': 1,
          'Instruction': 1
        },
        Connection_HY_Dongle: {
          'MessageType': 2,
          'Instruction': 3
        },
        Connection_HY_eBike: {
          'MessageType': 2,
          'Instruction': 4
        },
        Connection_HY_Status: {
          // keep connect
          'MessageType': 2,
          'Instruction': 108
        },
        Connection_HY_Console: {
          'MessageType': 2,
          'Instruction': 110
        },
        Connection_HY_Display: {
          'MessageType': 2,
          'Instruction': 111
        },
        Connection_HY_ChangeBike: {
          'MessageType': 2,
          'Instruction': 118
        },
        Connection_HY_CheckDeviceUnconnection: {
          'MessageType': 2,
          'Instruction': 135
        },
        Connection_HY_StopCheckDeviceUnconnection: {
          'MessageType': 2,
          'Instruction': 136
        },
        Information_HY_BikeInfo: {
          'MessageType': 4,
          'Instruction': 9
        },
        Information_HY_GetConsoleBtns: {
          'MessageType': 4,
          'Instruction': 100
        },
        Information_HY_Battery: {
          'MessageType': 4,
          'Instruction': 10
        },
        Information_HY_FirmwareVer: {
          'MessageType': 4,
          'Instruction': 11
        },
        Information_HY_ErrorCode: {
          'MessageType': 4,
          'Instruction': 12
        },
        Information_HY_ReadPara: {
          'MessageType': 4,
          'Instruction': 104
        },
        Information_HY_GetBikeId: {
          'MessageType': 4,
          'Instruction': 105
        },
        Information_HY_GetDeviceInfo: {
          'MessageType': 4,
          'Instruction': 106
        },
        Information_HY_WriteBikeId: {
          'MessageType': 4,
          'Instruction': 107
        },
        Information_HY_GetFrameNumber: {
          'MessageType': 4,
          'Instruction': 109
        },
        Information_HY_MAC: {
          'MessageType': 4,
          'Instruction': 112
        },
        Information_HY_Lighton: {
          'MessageType': 4,
          'Instruction': 113
        },
        Information_HY_CommonCustomizenInfo: {
          'MessageType': 4,
          'Instruction': 120
        },
        Information_HY_SystemConfig: {
          'MessageType': 4,
          'Instruction': 121
        },
        Information_HY_WriteFrameNo: {
          'MessageType': 4,
          'Instruction': 133
        },
        Information_HY_WriteMid: {
          'MessageType': 4,
          'Instruction': 142
        },
        Information_HY_GetUpdateStatus: {
          'MessageType': 4,
          'Instruction': 144
        },
        Information_HY_WriteParameters: {
          'MessageType': 4,
          'Instruction': 145
        },
        Diagnostics_Cancel: {
          'MessageType': 6,
          'Instruction': 35
        },
        Diagnostics_HY_Display_Status: {
          'MessageType': 6,
          'Instruction': 36
        },
        Diagnostics_HY_Display_Flash: {
          'MessageType': 6,
          'Instruction': 37
        },
        Diagnostics_HY_Display_Round: {
          'MessageType': 6,
          'Instruction': 38
        },
        Diagnostics_HY_Display_TestStop: {
          'MessageType': 6,
          'Instruction': 39
        },
        Diagnostics_HY_Console_Btns: {
          'MessageType': 6,
          'Instruction': 40
        },
        Diagnostics_HY_HallSensor: {
          'MessageType': 6,
          'Instruction': 41
        },
        Diagnostics_HY_Speed: {
          'MessageType': 6,
          'Instruction': 42
        },
        Diagnostics_HY_Torque: {
          'MessageType': 6,
          'Instruction': 43
        },
        Diagnostics_HY_Cadence: {
          'MessageType': 6,
          'Instruction': 44
        },
        Diagnostics_HY_Charger: {
          'MessageType': 6,
          'Instruction': 45
        },
        Diagnostics_HY_Controller: {
          'MessageType': 6,
          'Instruction': 46
        },
        Diagnostics_HY_Battery: {
          'MessageType': 6,
          'Instruction': 47
        },
        Diagnostics_Hallsensor_Status: {
          'MessageType': 6,
          'Instruction': 48
        },
        Diagnostics_Speed_Status: {
          'MessageType': 6,
          'Instruction': 49
        },
        Diagnostics_Torque_Status: {
          'MessageType': 6,
          'Instruction': 50
        },
        Diagnostics_Cadence_Status: {
          'MessageType': 6,
          'Instruction': 51
        },
        Diagnostics_BR_DU_Speed: {
          'MessageType': 6,
          'Instruction': 56
        },
        Diagnostics_BR_DU_Torque: {
          'MessageType': 6,
          'Instruction': 57
        },
        Diagnostics_BR_DU_Cadence: {
          'MessageType': 6,
          'Instruction': 58
        },
        Diagnostics_HY_FrontLight: {
          'MessageType': 6,
          'Instruction': 114
        },
        Diagnostics_HY_RearLight: {
          'MessageType': 6,
          'Instruction': 115
        },
        Diagnostics_HY_GripBrake: {
          'MessageType': 6,
          'Instruction': 116
        },
        Diagnostics_HY_MotorSpeed: {
          'MessageType': 6,
          'Instruction': 117
        },
        Diagnostics_HY_TirePressure: {
          'MessageType': 6,
          'Instruction': 119
        },
        Diagnostics_Motor: {
          'MessageType': 6,
          'Instruction': 143
        },
        BtnListener_StartBtnListener: {
          'MessageType': 8,
          'Instruction': 101
        },
        BtnListener_StopBtnListener: {
          'MessageType': 8,
          'Instruction': 103
        },
        Upgrade_HY_Dongle: {
          'MessageType': 5,
          'Instruction': 152
        },
        Upgrade_HY_Console: {
          'MessageType': 5,
          'Instruction': 30
        },
        Upgrade_HY_Driver: {
          'MessageType': 5,
          'Instruction': 31
        },
        Upgrade_HY_Display: {
          'MessageType': 5,
          'Instruction': 32
        },
        Upgrade_BR_DriveUnit: {
          'MessageType': 5,
          'Instruction': 33
        },
        Customize_HY_Write_MaintenanceWarning: {
          'MessageType': 7,
          'Instruction': 122
        },
        Customize_HY_Write_NextMaintenanceODO: {
          'MessageType': 7,
          'Instruction': 123
        },
        Customize_HY_Write_PowerLevels: {
          'MessageType': 7,
          'Instruction': 125
        },
        Customize_HY_Write_EnergyBar: {
          'MessageType': 7,
          'Instruction': 126
        },
        Customize_HY_Write_StartUpLightON: {
          'MessageType': 7,
          'Instruction': 127
        },
        Customize_HY_Write_SpeedUnits: {
          'MessageType': 7,
          'Instruction': 128
        },
        Customize_HY_Write_StartUpPowerLevel: {
          'MessageType': 7,
          'Instruction': 129
        },
        Customize_HY_Write_WheelSize: {
          'MessageType': 7,
          'Instruction': 130
        },
        Customize_HY_Write_AutoSleep: {
          'MessageType': 7,
          'Instruction': 132
        },
        Customize_HY_Write_Reset: {
          'MessageType': 7,
          'Instruction': 131
        },
        Customize_HY_ReadModePowerLevel: {
          'MessageType': 7,
          'Instruction': 134
        },
        Customize_HY_Write_TorqueResponse: {
          'MessageType': 7,
          'Instruction': 124
        },
        Customize_QW_PatchHideDisplayAstLevel: {
          MessageType: 7,
          Instruction: 158
        },
        Autoupdate_Check_Version: {
          'MessageType': 9,
          'Instruction': 148
        },
        Autoupdate_Download: {
          'MessageType': 9,
          'Instruction': 149
        },
        Autoupdate_Download_Cancel: {
          'MessageType': 9,
          'Instruction': 150
        },
        Autoupdate_Installer: {
          'MessageType': 9,
          'Instruction': 151
        }
      };
    },
    getWebSocketError: function () {
      return {
        API_KeyError: { 'ErrorCode': 20011, 'ErrorMessage': 'API Key Error' },
        Decryption: { 'ErrorCode': 20001, 'ErrorMessage': 'Receiving unknown data, please try again.' },
        DuplicateConnect: { 'ErrorCode': 20002, 'ErrorMessage': 'Duplicated connection.' },
        ReceiveDataError: { 'ErrorCode': 20003, 'ErrorMessage': 'Occured an error when websocket is receiving data.' },
        Req_MessageTypeError: { 'ErrorCode': 20004, 'ErrorMessage': 'MessageType value is unknown while receiving client message.' },
        Req_InstructionError: { 'ErrorCode': 20005, 'ErrorMessage': 'Instruction value is unknown while receiving client message.' },
        Res_MessageTypeError: { 'ErrorCode': 20006, 'ErrorMessage': 'MessageType value is unknown while receiving server message.' },
        Res_InstructionError: { 'ErrorCode': 20007, 'ErrorMessage': 'Instruction value is unknown while receiving server message.' },
        WebSocketError: { 'ErrorCode': 20008, 'ErrorMessage': 'WebSocket occured unkown error.' },
        Exception: { 'ErrorCode': 20009, 'ErrorMessage': 'MessageGateway occured exception.' },
        FoolProofing: { 'ErrorCode': 20010, 'ErrorMessage': 'Do not continue sending instructions.' }
      };
    },
    getMessageType: function () {
      return {
        Verification: 1,
        Connection: 2,
        ListenBtn: 8,
        Information: 4,
        Upgrade: 5,
        Diagnostics: 6,
        Customized: 7,
        Exception: 98,
        DecryptionError: 99,
        FoolProofing: -1,
        AutoUpdate: 9
      };
    },
    getListenBtnInstruction: function () {
      return {
        StartListenBtn: 101,
        DetectBtn: 102,
        StopListenBtn: 103,
        KeyError: 499
      };
    },
    getConnectInstruction: function () {
      return {
        HY_Dongle: 3,
        HY_eBike: 4,
        HY_ConnctStatus: 108,
        HY_Console: 110,
        HY_Display: 111,
        HY_ChangeBike: 118,
        HY_CheckDeviceUnconnection: 135,
        HY_StopCheckDeviceUnconnection: 136,
        KeyError: 499
      };
    },
    getInfoInstruction: function () {
      return {
        HY_GetConsoleBtns: 100,
        HY_BikeInfo: 9,
        HY_Battery: 10,
        HY_FirmwareVer: 11,
        HY_ErrorCode: 12,
        HY_ReadPara: 104,
        HY_GetBikeId: 105,
        HY_GetDeviceInfo: 106,
        HY_WriteBikeId: 107,
        HY_GetFrameNumber: 109,
        HY_MAC: 112,
        HY_Lighton: 113,
        HY_CommonCustomizenInfo: 120,
        HY_SystemConfig: 121,
        HY_WriteFrameNo: 133,
        HY_WriteMid: 142,
        HY_GetUpdateStatus: 144,
        HY_WriteParameters: 145,
        KeyError: 499
      };
    },
    getDiagnosistInstruction: function () {
      return {
        Diagnostics_Cancel: 35,
        HY_Display_Status: 36,
        HY_Display_Flash: 37,
        HY_Display_Round: 38,
        HY_Display_TestStop: 39,
        HY_Console_Btns: 40,
        HY_HallSensor: 41,
        HY_Speed: 42,
        HY_Torque: 43,
        HY_Cadence: 44,
        HY_Charger: 45,
        HY_Controller: 46,
        HY_Battery: 47,
        HY_Hallsensor_Status: 48,
        HY_Speed_Status: 49,
        HY_Torque_Status: 50,
        HY_Cadence_Status: 51,
        HY_FrontLight: 114,
        HY_RearLight: 115,
        HY_GripBrake: 116,
        HY_MotorSpeed: 117,
        HY_TirePressure: 119,
        BR_DU_Speed: 56,
        BR_DU_Torque: 57,
        BR_DU_Cadence: 58,
        HY_Motor: 143,
        KeyError: 499
      };
    },
    getUpgrdeInstruction: function () {
      return {
        HY_Dongle: 152,
        HY_Console: 30,
        HY_Driver: 31,
        HY_Display: 32,
        BR_DriveUnit: 33
      };
    },
    getCustomizeInstruction: function () {
      return {
        HY_Write_MaintenanceWarning: 122,
        HY_Write_NextMaintenanceODO: 123,
        HY_Write_PowerLevels: 125,
        HY_Write_EnergyBar: 126,
        HY_Write_StartUpLightON: 127,
        HY_Write_SpeedUnits: 128,
        HY_Write_StartUpPowerLevel: 129,
        HY_Write_WheelSize: 130,
        HY_Write_Reset: 131,
        HY_Write_AutoSleep: 132,
        HY_ReadModePowerLevel: 134,
        HY_Write_TorqueResponse: 124,
        QW_PatchHideDisplayAstLevel: 158
      };
    },
    getAutoUpdateInstruction: function () {
      return {
        Check_Version: 148,
        Download: 149,
        Download_Cancel: 150,
        Installer: 151,
        KeyError: 499
      };
    },
    getMGStatusCode: function () {
      return {
        Pass: 1000,
        Fail: 1001,
        Test_Timer: 1300,
        Test_Button: 1301,
        Test_Value: 1304,
        Cancel_Diagnosis: 1302
      };
    },
    getButtonName: function () {
      return {
        w: 'w',
        u: 'u',
        d: 'd'
      };
    }
  };
}());
var CheckFormat = (function () {
  return {
    seconds: function (sec) {
      var numSec = parseInt(sec);
      var rep = /^[0-9]*$/;
      var returnSeconds = 30;
      if (!rep.test(numSec)) {
        returnSeconds = 30;
      } else if (numSec > 180 || numSec < 0) {
        returnSeconds = 30;
      } else {
        returnSeconds = numSec;
      }
      return returnSeconds;
    },
    time: function (times) {
      var numTimes = parseInt(times);
      var rep = /^[0-9]*$/;
      var returnTime = 3;
      if (!rep.test(numTimes)) {
        returnTime = 3;
      } else if (numTimes > 10 || numTimes < 0) {
        returnTime = 3;
      } else {
        returnTime = numTimes;
      }
      return returnTime;
    }
  };
}());

var RequestAPI = (function () {
  return {
    CallHyenaAPI (apiName, params, callback) {
      let apiUrl = 'https://mg-bl-dev.hylink.io:443';
      fetch(apiUrl + apiName, { body: params, method: 'POST' })
        .then((response) => {
          if (!response.ok) {
            return {
              'ErrorCode': 25012,
              'ErrorMessage': 'Occur an error, please contact the system provider.'
            };
          }
          return response.json();
        }).then((data) => {
          // // console.log(data)
          callback(data);
        });
    },
    CallGetPartFWData (apiName, params, callback) {
      let apiUrl = 'http://192.168.0.22:4000';
      fetch(apiUrl + apiName, { body: params, method: 'POST' })
        .then((response) => {
          if (!response.ok) {
            return {
              'ErrorCode': 25012,
              'ErrorMessage': 'Occur an error, please contact the system provider.'
            };
          }
          return response.json();
        }).then((data) => {
          // // console.log(data)
          callback(data);
        });
    }
  };
}());

export { MGConstants, RequestAPI };
